module.exports = __webpack_public_path__ + "img/Reserve_and_Pickup.fde65976.svg";